import { makeStyles } from '@material-ui/styles'
import React, { ReactNode } from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Tooltip from 'core/elements/tooltip/Tooltip'
import Theme from 'core/themes/model'

interface Props {
  label: string | ReactNode
  tooltip: string | ReactNode
  icon: string
  disabled?: boolean
}

export default function DropdownItemWithTooltip({ label, tooltip, icon, disabled = false }: Props) {
  const classes = useStyles()

  return (
    <div className={classes.dropdownWithTooltip}>
      {label}
      <Tooltip message={tooltip}>
        <FontAwesomeIcon className={disabled && classes.disabled}>{icon}</FontAwesomeIcon>
      </Tooltip>
    </div>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  dropdownWithTooltip: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'calc(100% - 16px)', // Counteract padding in DropdownItem component
  },
  disabled: {
    cursor: 'not-allowed',
    color: theme.palette.grey[300],
  },
}))
